import React, { useEffect, useRef } from "react";
import { IoMdClose } from "react-icons/io";
export const SidePopup:React.FC = (props: any) => {
  const {
    handleClose,
    // onClick,
    showModal,
    title,
    children,
    width,
    footerContent,
    closeIconStyle,
    bodyClass,
    topButton,
    iconColor,
    closeIcon,
    footerStyle,
    clearFormik,
  } = props;

  const divRef = useRef(null) as any;
  const SubdivRef = useRef(null) as any;
  useEffect(() => {
    SubdivRef.current?.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });
    divRef.current?.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });
  }, [showModal]);
  return (
    <div>
      <div
        className={`${
          showModal ? "block" : "hidden"
        } fixed inset-0 z-50 bg-[#0000004D]  w-full h-full`}
        style={{ backdropFilter: "blur(2px)" }}
      >
        <div className="flex justify-end w-full  ">
          <div
            ref={divRef}
            id="scroll"
            className={`relative bg-white shadow  w-full max-h-[99vh]  overflow-y-auto scroll-bar ${
              width ? width : "max-w-[550px]"
            }`}
          >
            <div className="relative w-full  rounded-[8px] px-[20px] md:px-[24px]">
              <div className="flex w-full items-center justify-between  pb-[16px] sticky top-0 bg-white py-[24px] z-50 ">
                <h3 className="text-[20px] font-semibold">{title}</h3>
                <div className="flex items-center justify-end">
                  {topButton}
                  {!closeIcon && (
                    <button
                      onClick={() => {
                        //eslint-disable-next-line
                        clearFormik ? clearFormik() : null; // clear formik data when true
                        handleClose();
                      }}
                      type="button"
                      className={`${closeIconStyle} bg-transparent border-[#E8ECF4] border 
                      rounded-[8px]  
                      ml-[12px] p-[10px] inline-flex justify-center items-center hover:bg-gray-100`}
                    >
                      <IoMdClose
                        color={iconColor ? "white" : "black"}
                        size={20}
                      />
                    </button>
                  )}
                </div>
              </div>
              <div
                className={`${
                  bodyClass ? bodyClass : footerContent ? "min-h-[calc(100vh-174px)] overflow-y-auto" : "min-h-[88vh] "
                } overflow-y-auto w-full `}
                ref={SubdivRef}
              >
                {children}
              </div>
            </div>
            {footerContent && (
              <div
                className={`sticky bottom-0 z-40 items-end pt-[16px] pb-[24px] px-[20px] md:px-[24px] w-full bg-white ${footerStyle} `}
              >
                {footerContent}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
